import React from 'react';
import { Flex, Box, Text } from 'rebass';
import {
  ButtonLarge,
  TermsAndConditions,
  OrDivider,
  FormHeader,
  FormSubHeader,
  ErrorNotification,
} from '@mdlinx/component-library';

import { FormContainer } from 'app/components/layout/form-container';

export type SignUpFormEmailOrSocialProps = {
  header: string;
  subHeader: string;
  socialButtons?: React.ReactNode;
  onClickEmailSignUp?: () => void;
  errorMessage?: string;
  onLoginLinkClicked?: () => void;
};

export const SignUpFormEmailOrSocial = ({
  header,
  subHeader,
  socialButtons,
  onClickEmailSignUp,
  errorMessage,
}: SignUpFormEmailOrSocialProps) => {
  return (
    <FormContainer alternativeScene="login">
      {errorMessage && (
        <Box my="12px">
          <ErrorNotification errorMessage={errorMessage} />
        </Box>
      )}
      <Text textAlign="center">
        <FormHeader>{header}</FormHeader>
      </Text>
      <Box mt="10px" />
      <FormSubHeader width="100%" textAlign="center" px="42px">
        {subHeader}
      </FormSubHeader>
      <Box mt="20px" />
      <Box width="100%" mb={['17px', '30px']}>
        <ButtonLarge onClick={onClickEmailSignUp}>Sign Up with Email</ButtonLarge>
        <OrDivider />
        <Box mb="40px">{socialButtons}</Box>
      </Box>
      <Flex justifyContent="center" px="80px" sx={{ textAlign: 'center' }}>
        <TermsAndConditions />
      </Flex>
    </FormContainer>
  );
};
